import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ISonURL } from '../../types/IUrl';
import { BlockBar } from '../../_lib/components/BlockBar';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ContentLink } from '../../_lib/components/ContentLink';
import { TooltipPlacement } from '../../components/atoms/Tooltip';

type UserSourcesList = {
  userSourcesLinks: ISonURL[];
};

function UserSourcesList({ userSourcesLinks }: UserSourcesList) {
  const { t } = useSonTranslation('UserSourcesList');

  return (
    <>
      <BlockBar heading={t('blockHeading')} hierarchy={3} />
      <div className="block-bar__controlled-container-padding">
        <ul>
          {userSourcesLinks.map(link => {
            return (
              <li key={link.url} className="user-sources-list__list-item">
                <ContentLink
                  key={link.url}
                  to={link.url}
                  target="_blank"
                  external
                  newWindowIndicator
                  title={t('openInNewWindow')}
                  tooltipPlacement={TooltipPlacement.BOTTOM}
                >
                  {link.name}
                </ContentLink>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}

export const UserSourcesListBlock = asFetchableBlock(UserSourcesList, BlockType.usersourceslist);
export type UserSourcesListBlock = ComponentProps<typeof UserSourcesListBlock>;
